import TestRenderer from 'react-test-renderer';

export const createWithEffects = (element) => {
    let renderer;
    TestRenderer.act(() => {
        renderer = TestRenderer.create(element);
    });
    return renderer;
};

const wrapHandler = (handler, act) => (data) => {
    let newData;
    let error;
    act(() => {
        try {
            newData = handler(data);
        } catch (e) {
            error = e;
        }
    });
    if (error) {
        throw error;
    }
    return newData;
};

export class WrappedTestRendererPromise extends Promise {
    then = (onResolve, onReject) =>
        super.then(
            onResolve && wrapHandler(onResolve, TestRenderer.act),
            onReject && wrapHandler(onReject, TestRenderer.act)
        );
}
